var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRsTikTok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24/Login/RS Tik Tok"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.84047 19.67C7.50047 19.67 5.60047 17.77 5.60047 15.43C5.60047 13.09 7.50047 11.19 9.84047 11.19C10.2505 11.19 10.5905 11.53 10.5905 11.94C10.5905 12.35 10.2505 12.69 9.84047 12.69C8.33047 12.69 7.10047 13.92 7.10047 15.43C7.10047 16.94 8.33047 18.17 9.84047 18.17C11.3505 18.17 12.5805 16.94 12.5805 15.43V5.12002C12.5805 4.71002 12.9205 4.37002 13.3305 4.37002C13.7405 4.37002 14.0805 4.71002 14.0805 5.12002C14.0805 7.06002 15.6605 8.63002 17.5905 8.63002C18.0005 8.63002 18.3405 8.97002 18.3405 9.38002C18.3405 9.79002 18.0005 10.13 17.5905 10.13C16.2205 10.13 14.9805 9.58002 14.0805 8.69002V15.43C14.0805 17.77 12.1805 19.67 9.84047 19.67Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9805 22.77H5.98047C3.36047 22.77 1.23047 20.64 1.23047 18.02V6.02002C1.23047 3.40002 3.36047 1.27002 5.98047 1.27002H17.9805C20.6005 1.27002 22.7305 3.40002 22.7305 6.02002V18.02C22.7305 20.64 20.6005 22.77 17.9805 22.77ZM5.98047 2.77002C4.19047 2.77002 2.73047 4.23002 2.73047 6.02002V18.02C2.73047 19.81 4.19047 21.27 5.98047 21.27H17.9805C19.7705 21.27 21.2305 19.81 21.2305 18.02V6.02002C21.2305 4.23002 19.7705 2.77002 17.9805 2.77002H5.98047Z",
    fill: "#FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsTikTok);
export default __webpack_public_path__ + "static/media/RSTikTok.ed0591017bcc14d9dad9deb97ceab759.svg";
export { ForwardRef as ReactComponent };